import { z } from 'zod';

export const Rating = z.number().min(0).max(5).nullable();

export type Rating = z.infer<typeof Rating>;
